/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-useless-catch */
import { Injectable, inject } from '@angular/core';
import { Auth } from 'aws-amplify';
import { User } from '../types/core';
import { BehaviorSubject } from 'rxjs';
import { API } from 'aws-amplify';
import { GraphQLQuery } from '@aws-amplify/api';
import { GetUserQuery, GetUserQueryVariables, queries } from 'kms-amplify/src';
import { DataMappingService } from './data-mapping.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticateService {
  dataMappingService = inject(DataMappingService);
  loggedInUser = new BehaviorSubject<User | null>(null);

  async checkAuth() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      console.log('CHECK AUTH : ', user);
      const loggedInUser = this.loggedInUser.getValue();
      if (!loggedInUser) await this.getUser();
      return user;
    } catch (err) {
      throw err;
    }
  }

  async signIn(email: string, password: string) {
    try {
      const user = await Auth.signIn(email, password);
      console.log('USER SIGNED IN : ', user);
      this.getUser();
      return user;
    } catch (err: any) {
      const errString = String(err);
      if (errString.indexOf('UserNotFoundException') >= 0) {
        throw 'User not found';
      } else {
        throw err;
      }
    }
  }

  async confirmNewPassword(user: any, newPassword: string) {
    try {
      const newUser = Auth.completeNewPassword(user, newPassword);
      return newUser;
    } catch (err) {
      throw err;
    }
  }

  async signout() {
    try {
      await Auth.signOut();
    } catch (err) {
      throw err;
    }
  }

  async getUser() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const userSub = user?.attributes?.sub;
      if (!userSub) throw 'no current user';
      const variables: GetUserQueryVariables = {
        id: userSub,
      };
      const userResult = (
        await API.graphql<GraphQLQuery<GetUserQuery>>({
          query: queries.getUser,
          variables,
        })
      ).data?.getUser;
      console.log('USER QUERY : ', userResult);
      // observable
      this.loggedInUser.next(this.dataMappingService.getUser(userResult));
    } catch (err) {
      throw err;
    }
  }
}
